export const extraContentNamespace = 'filesTable.extraContent';
export const batchActionsNamespace = 'filesTable.extraContent.batchActions';
